import React from "react";
import InputField from "../../../../components/InputField";
import DocumentUpload from "../../../../components/DocumentUpload";
import "./index.scss";

const MSMESection = ({
  isMSMERegistered,
  formData,
  errors,
  handleChange,
  handleBlur,
  msmeFile,
  handleMsmeFileChange,
  existingMsmeFile,
  onViewExisting,
  readOnly = false,
  isDeficient = false,
  isUploading = false,
}) => {
  if (isMSMERegistered !== "yes") return null;

  return (
    <div
      className={`msme-section${isDeficient ? " msme-section--deficient" : ""}`}
    >
      {isDeficient && (
        <div className="deficiency-notice">
          ⚠ Deficiency — please re-upload the MSME Certificate
        </div>
      )}
      <div className="msme-section__row">
        <InputField
          name="msmeNumber"
          label="MSME Registration Number"
          type="text"
          placeholder="Enter MSME number"
          value={formData.msmeNumber || ""}
          maxLength={19}
          onChange={readOnly ? undefined : handleChange}
          onBlur={readOnly ? undefined : handleBlur}
          error={errors.msmeNumber}
          required
          readOnly={readOnly}
        />
        <DocumentUpload
          label="MSME Certificate"
          name="msme_file"
          file={msmeFile}
          existingFile={existingMsmeFile || null}
          onViewExisting={onViewExisting}
          onChange={(e) => {
            if (isUploading) return;
            const file = e.target.files[0];
            if (!file) return;
            handleMsmeFileChange(file);
          }}
          required
          disabled={(readOnly && !isDeficient) || isUploading}
          isUploading={isUploading}
          className={isDeficient ? "doc-upload--deficient" : ""}
        />
      </div>
    </div>
  );
};

export default MSMESection;
